module.exports = __webpack_public_path__ + "static/media/magic bus ngo film.d760aa77.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/magic bus ngo film.gif
// module id = 361
// module chunks = 0